
  import { css } from 'lit';
  export const styles = css`:host{--box-background-focus: var(--ig-chat-box-background-focus, var(--ig-gray-300));--focused-bottom-line-color: var(--ig-chat-focused-bottom-line-color, var(--ig-primary-500));--ig-theme: material;--ig-theme-variant: light}`;
  